import { css } from "@emotion/react";
import ArrowForward from "@material-ui/core/SvgIcon";
import styled from "../../../../../../config/emotion";
import { StyledCompProps } from "../../../../../../globalTypes/theme";
import { NotificationIndicatorFavourite } from "../favourite/styles";

export const outerContainerCss = css`
  width: 95%;
  height: auto;
  margin: 0.4em 0.6em;
  padding: 5px;
  text-decoration: none;
  position: relative;
  border-radius: 5px;
  border: 1px solid #e7e8ec;

  @media only screen and (max-width: 600px) {
    width: 90%;
    margin: 0.4em auto;
    padding-right: 60px;
  }
`;

export const innerContainerCss = css`
  display: flex;
  flex-direction: row;
  padding: 5px;
  text-align: left;
  justify-content: space-between;

  text-decoration: none;
`;

export const labelWrapperCss = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 3px 0;
  position: relative;
  width: 100%;
`;

export const LabelWrapper = styled.span`
  ${labelWrapperCss}
  & > span {
    color: ${({ theme }) => theme.colors.secondaryColor};
  }
`;
const getStylesForRightModuleIcons = () => css`
  position: absolute;
  right: 5px;
  bottom: 5px;
  font-size: 20px;
  cursor: pointer;
  top: 50%;
  transform: translateY(-50%);

  @media only screen and (max-width: 600px) {
    font-size: 24px;
  }
`;
export const ToggleStarModule = styled.div`
  position: absolute;
  font-size: 20px;
  cursor: pointer;
  top: 50%;
  right: 7px;
  transform: translateY(-50%);
`;

export const ArrowIconModule = styled(ArrowForward)<StyledCompProps>`
  color: ${({ theme }) => theme.colors.primaryColor};
  ${getStylesForRightModuleIcons};
  bottom: 5px;
  @media only screen and (max-width: 600px) {
    display: none;
  }
`;

export const infoButtonCss = css`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 2.5rem;
`;

export const NotificationIndicatorModule = NotificationIndicatorFavourite;

export const labelPaddingCss = (isMobile: boolean) => css`
  margin-right: ${isMobile ? 0 : 48}px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
